import axios from 'axios';
import config from '../config';
import { getBearerToken } from '../util/cookie';

// ================ Action types ================ //

export const CREDENTIALS_REQUEST = 'app/CoachSaaS/CREDENTIALS_REQUEST';
export const CREDENTIALS_SUCCESS = 'app/CoachSaaS/CREDENTIALS_SUCCESS';
export const CREDENTIALS_ERROR = 'app/CoachSaaS/CREDENTIALS_ERROR';

// ================ Reducer ================ //

const initialState = {
  credentials: [],
  credentialsFetching: false,
  credentialsError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case CREDENTIALS_REQUEST:
      return { ...state, credentialsFetching: true, credentialsError: null };
    case CREDENTIALS_SUCCESS:
      return { ...state, credentialsFetching: false, credentials: payload };
    case CREDENTIALS_ERROR:
      return { ...state, credentialsFetching: false, credentialsError: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const credentialsRequest = () => ({ type: CREDENTIALS_REQUEST });
export const credentialsSuccess = (d) => ({ type: CREDENTIALS_SUCCESS, payload: d });
export const credentialsError = (e) => ({ type: CREDENTIALS_ERROR, payload: e });

// ================ Thunks ================ //

// Submit a new credential. `payload` includes the file metadata
// (fileUrl, fileName, fileSize, fileType) — the actual upload to
// Firebase Storage happens on the page BEFORE we hit this endpoint.
export const submitCredential = (payload) => async (dispatch, getState, sdk) => {
  return axios.post(
    `${config.coachSaaSService}credentials/submit`,
    { payload },
    {
      headers: {
        'content-type': 'application/json',
        Authorization: await getBearerToken(sdk),
      },
    }
  );
};

export const fetchMyCredentials = () => async (dispatch, getState, sdk) => {
  dispatch(credentialsRequest());
  try {
    const res = await axios.post(
      `${config.coachSaaSService}credentials/list`,
      {},
      {
        headers: {
          'content-type': 'application/json',
          Authorization: await getBearerToken(sdk),
        },
      }
    );
    dispatch(credentialsSuccess((res.data && res.data.credentials) || []));
    return res.data;
  } catch (e) {
    dispatch(credentialsError(e));
    throw e;
  }
};

export const deleteCredential = (credentialId) => async (dispatch, getState, sdk) => {
  return axios.post(
    `${config.coachSaaSService}credentials/delete`,
    { credentialId },
    {
      headers: {
        'content-type': 'application/json',
        Authorization: await getBearerToken(sdk),
      },
    }
  );
};

// ─── Admin thunks (Viveka admins only) ───
// Backend gates these with adminAuth — non-admins get a 403.

export const fetchAdminCredentials = (statusFilter = 'pending', limit = 100) => async (dispatch, getState, sdk) => {
  return axios.post(
    `${config.coachSaaSService}credentials/admin/credentials/pending`,
    { status: statusFilter, limit },
    {
      headers: {
        'content-type': 'application/json',
        Authorization: await getBearerToken(sdk),
      },
    }
  );
};

export const adminApproveCredential = (coachId, credentialId) => async (dispatch, getState, sdk) => {
  return axios.post(
    `${config.coachSaaSService}credentials/admin/credentials/approve`,
    { coachId, credentialId },
    {
      headers: {
        'content-type': 'application/json',
        Authorization: await getBearerToken(sdk),
      },
    }
  );
};

export const adminRejectCredential = (coachId, credentialId, reason) => async (dispatch, getState, sdk) => {
  return axios.post(
    `${config.coachSaaSService}credentials/admin/credentials/reject`,
    { coachId, credentialId, reason },
    {
      headers: {
        'content-type': 'application/json',
        Authorization: await getBearerToken(sdk),
      },
    }
  );
};
